import * as React from 'react'

/**
 * @description AppStore icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { AppStore } from '@sravni/design-system-icons'
 *
 * <AppStore />
 * ```
 */
export const AppStore = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="AppStore" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.43 10.827c-.02-2.147 1.78-3.192 1.862-3.241-1.02-1.468-2.599-1.669-3.154-1.685-1.327-.138-2.614.785-3.29.785-.689 0-1.73-.771-2.851-.749-1.444.022-2.794.848-3.535 2.13-1.528 2.614-.388 6.456 1.076 8.569.732 1.035 1.588 2.19 2.709 2.15 1.096-.045 1.505-.69 2.828-.69 1.31 0 1.695.69 2.838.664 1.176-.02 1.916-1.04 2.623-2.084.847-1.186 1.187-2.354 1.2-2.414-.027-.01-2.284-.86-2.306-3.435ZM13.271 4.511c.59-.728.993-1.719.881-2.724-.853.037-1.92.583-2.535 1.295-.543.628-1.029 1.657-.904 2.624.959.07 1.943-.478 2.558-1.195Z"
      fill="currentColor"
    />
  </svg>
))
